import { useEffect, useState } from 'react';

import { checkApplePayAvailability } from '@/lib/payment/helpers';

/**
 * Check Apple Pay availability in the current environment.
 */
export const useApplePayAvailability = (): boolean | null => {
  const [isAvailable, setIsAvailable] = useState<boolean | null>(null);

  useEffect(() => {
    let active = true;

    (async () => {
      const result = await checkApplePayAvailability();
      if (active) {
        setIsAvailable(result);
      }
    })();

    return () => {
      active = false;
    };
  }, []);

  return isAvailable;
};
